const actionTypes = {
  SET_CRITICAL_ERROR: '@MYYOLA/ERROR/SET_CRITICAL_ERROR',
};

export default actionTypes;
